//
//
//
//
//
//

import { sendCtmEvtLog } from '@/utils/log'
export default {
    methods: {
        backToTop() {
            sendCtmEvtLog(`${this.sourse}点击-回到顶部`)
            wx.pageScrollTo({
                scrollTop: 0
            })
        }
    },
    props: {
        sourse: {
            type: String
        }
    }
}
